
const WhyChooseUs = () => {
  const benefits = [
    {
      icon: "ri-government-line",
      title: "Authorized Partner",
      description: "Official PM Surya Ghar Yojana 2025 partner with guaranteed subsidy processing",
      color: "emerald",
      stats: "100% Subsidy Assistance"
    },
    {
      icon: "ri-shield-check-line",
      title: "Premium Brands",
      description: "Top-quality solar panels and batteries from trusted brands like Luminous & Exide",
      color: "blue",
      stats: "25 Year Warranty"
    },
    {
      icon: "ri-tools-line",
      title: "Expert Installation",
      description: "Certified professionals ensure safe, efficient installation with ongoing maintenance",
      color: "amber",
      stats: "10,000+ Installations"
    },
    {
      icon: "ri-money-rupee-circle-line",
      title: "Flexible Payment",
      description: "Easy EMI options and financing solutions to make solar affordable for everyone",
      color: "purple",
      stats: "0% Interest Available"
    },
    {
      icon: "ri-time-line",
      title: "Working Hours",
      description: "Mon - Sat: 10:00 AM - 5:00 PM, Sunday: Closed",
      color: "rose",
      stats: "Mon - Sat: 10 AM - 5 PM"
    },
    {
      icon: "ri-leaf-line",
      title: "Eco-Friendly",
      description: "Reduce your carbon footprint while saving money with clean, renewable energy",
      color: "green",
      stats: "80% Bill Reduction"
    }
  ];

  const colorClasses: Record<string, { bg: string; light: string; text: string; border: string }> = {
    emerald: {
      bg: "from-emerald-500 to-emerald-600",
      light: "bg-emerald-50",
      text: "text-emerald-600",
      border: "border-emerald-200"
    },
    blue: {
      bg: "from-blue-500 to-blue-600",
      light: "bg-blue-50",
      text: "text-blue-600",
      border: "border-blue-200"
    },
    amber: {
      bg: "from-amber-500 to-amber-600",
      light: "bg-amber-50",
      text: "text-amber-600",
      border: "border-amber-200"
    },
    purple: {
      bg: "from-purple-500 to-purple-600",
      light: "bg-purple-50",
      text: "text-purple-600",
      border: "border-purple-200"
    },
    rose: {
      bg: "from-rose-500 to-rose-600",
      light: "bg-rose-50",
      text: "text-rose-600",
      border: "border-rose-200"
    },
    green: {
      bg: "from-green-500 to-green-600",
      light: "bg-green-50",
      text: "text-green-600",
      border: "border-green-200"
    }
  };

  return (
    <section id="benefits" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center bg-emerald-100 text-emerald-700 px-4 py-2 rounded-full text-sm font-medium mb-4">
            <i className="ri-star-line mr-2"></i>
            Why Choose Us
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            India's Most Trusted
            <span className="block text-transparent bg-gradient-to-r from-emerald-600 to-amber-500 bg-clip-text">
              Solar Partner
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Join thousands of satisfied customers who have transformed their homes with our 
            premium solar solutions and exceptional service.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {benefits.map((benefit, index) => {
            const colors = colorClasses[benefit.color];
            return (
              <div
                key={index}
                className="group bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border border-gray-100"
              >
                <div className="relative mb-6">
                  <div className={`w-16 h-16 bg-gradient-to-r ${colors.bg} rounded-2xl flex items-center justify-center mb-4 shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                    <i className={`${benefit.icon} text-white text-2xl`}></i>
                  </div>
                  <div className={`inline-block ${colors.light} ${colors.text} px-3 py-1 rounded-full text-sm font-semibold`}>
                    {benefit.stats}
                  </div>
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-emerald-600 transition-colors">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {benefit.description.split(/(Closed)/i).map((part, idx) =>
                    /closed/i.test(part) ? (
                      <span key={idx} className="text-red-600 font-medium">{part}</span>
                    ) : (
                      <span key={idx}>{part}</span>
                    )
                  )}
                </p>

                <div className={`mt-6 pt-6 border-t ${colors.border}`}>
                  <div className="flex items-center text-sm font-medium text-gray-500">
                    <i className="ri-arrow-right-line mr-2 group-hover:translate-x-1 transition-transform"></i>
                    Learn more about this benefit
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Stats Section */}
        <div className="mt-20">
          <div className="bg-gradient-to-r from-emerald-600 via-emerald-700 to-amber-600 rounded-3xl p-12 text-white">
            <div className="grid md:grid-cols-4 gap-8 text-center">
              <div className="space-y-2">
                <div className="text-4xl md:text-5xl font-bold text-emerald-200">10,000+</div>
                <div className="text-emerald-100 font-medium">Happy Customers</div>
                <div className="text-sm text-emerald-200 opacity-90">Across Haryana</div>
              </div>
              <div className="space-y-2">
                <div className="text-4xl md:text-5xl font-bold text-amber-200">₹78,000</div>
                <div className="text-amber-100 font-medium">Max Subsidy</div>
                <div className="text-sm text-amber-200 opacity-90">Government Support</div>
              </div>
              <div className="space-y-2">
                <div className="text-4xl md:text-5xl font-bold text-blue-200">25</div>
                <div className="text-blue-100 font-medium">Years Warranty</div>
                <div className="text-sm text-blue-200 opacity-90">Long-term Reliability</div>
              </div>
              <div className="space-y-2">
                <div className="text-4xl md:text-5xl font-bold text-green-200">80%</div>
                <div className="text-green-100 font-medium">Bill Reduction</div>
                <div className="text-sm text-green-200 opacity-90">Average Savings</div>
              </div>
            </div>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6">
          <div className="bg-gray-50 rounded-xl p-6 text-center">
            <i className="ri-award-line text-3xl text-amber-500 mb-3"></i>
            <div className="font-semibold text-gray-900">Certified Partner</div>
            <div className="text-sm text-gray-600">Government Authorized</div>
          </div>
          <div className="bg-gray-50 rounded-xl p-6 text-center">
            <i className="ri-shield-check-line text-3xl text-emerald-500 mb-3"></i>
            <div className="font-semibold text-gray-900">Quality Assured</div>
            <div className="text-sm text-gray-600">Premium Components</div>
          </div>
          <div className="bg-gray-50 rounded-xl p-6 text-center">
            <i className="ri-time-line text-3xl text-blue-500 mb-3"></i>
            <div className="font-semibold text-gray-900">Working Hours</div>
            <div className="text-sm text-gray-600">Mon - Sat: 10 AM - 5 PM</div>
            <div className="text-sm text-red-600 font-medium">Sunday: Closed</div>
          </div>
          <div className="bg-gray-50 rounded-xl p-6 text-center">
            <i className="ri-bank-card-line text-3xl text-purple-500 mb-3"></i>
            <div className="font-semibold text-gray-900">Easy Financing</div>
            <div className="text-sm text-gray-600">Flexible EMI Options</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
